import { combineReducers } from "redux";
import authReducer from "./authReducer";
import employeeReducer from "./employeeReducer";
import attendanceReducer from "./attendanceReducer";
import taskReducer from "./taskReducer";
import geofenceReducer from "./geofenceReducer";
import locationReducer from "./locationReducer";
import userReducer from "./userReducer";
import userBulkUploadReducer from "./userBulkUploadReducer";
import districtsReducer from "./districtsReducer";
import municipalitiesReducer from "./municipalitiesReducer";
import adminReducer from "./AdminReducer";
import parkGeofenceReducer from "./parkGeofenceReducer";
import attendanceReportReducer from "./attendanceReportReducer";
import beneficiariesReducer from "./survey-management/beneficiariesReducer";
import beneficiarySurveyReducer from "./survey-management/beneficiarySurveyReducer";
import internalReducer from "./internal/internalReducer";
import surveyOfficerReducer from "./user-management/surveyOfficerReducer";
import adminDashboardReducer from "./admin-dashboard/AdminDashboardReducer";
import roleReducer from "./role-management/role/roleReducer";
import permissionReducer from "./role-management/permission/permissionReducer";
import assignPermissionReducer from "./role-management/assignPermission/assignPermissionReducer";
import ulbUserReducer from "./user-management/ulbUserReducer";
import resetPasswordReducer from "./profile/resetPasswordReducer";
import constituencyReducer from "./user-management/constituencyReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  employee: employeeReducer,
  attendance: attendanceReducer,
  task: taskReducer,
  geofence: geofenceReducer,
  location: locationReducer,
  User: userReducer,
  userBulkUpload: userBulkUploadReducer,
  districtsData: districtsReducer,
  municipalitiesData: municipalitiesReducer,
  admin: adminReducer,
  parkGeofence: parkGeofenceReducer,
  attendanceReport: attendanceReportReducer,
  beneficiaries: beneficiariesReducer,
  beneficiarySurvey: beneficiarySurveyReducer,
  internal: internalReducer,
  surveyOfficer: surveyOfficerReducer,
  adminDashboard: adminDashboardReducer,
  role: roleReducer,
  permission: permissionReducer,
  assignPermission: assignPermissionReducer,
  ulbUser: ulbUserReducer,
  resetPassword: resetPasswordReducer,
  constituency: constituencyReducer,
});

export default rootReducer;
